export enum QueryKey {
  ACCEPT_INVITE_STAKEHOLDER = 'accept-invite-stakeholder',
  ACTIVATE_COUPON = 'activate-coupon',
  ADD_TEAM_MEMBER = 'add-team-member',
  ADJUST_POOL_SIZE = 'adjust-pool-size',
  APPROVE_TARGET_BASED_MILESTONE = 'approve-target-based-milestone',
  /** Agent eval fixtures only — not production API */
  ARCHIVE_WIDGET_EVAL = 'archive-widget-eval',
  AUTH_CHECK = 'auth-check',
  BULK_GRANT_DOWNLOAD_TEMPLATE = 'bulk-grant-download-template',
  BULK_STAKEHOLDER_ACTIONS = 'bulk-stakeholder-actions',
  /** Agent eval fixtures only — not production API */
  BULK_WIDGET_EVAL = 'bulk-widget-eval',
  CALC_CAP_TABLE = 'calc-cap-table',
  CALC_CUSTOM_SAFE = 'calc-custom-safe',
  CALC_FINAL_EXERCISE_DATE = 'calc-final-exercise-date',
  CALC_LAST_VESTING_DATE = 'calc-last-vesting-date',
  CALC_SCENARIO_INVESTMENT = 'calc-scenario-investment',
  CALC_SCENARIO_SAFES = 'calc-scenario-safes',
  CANCEL_STAKEHOLDER_INVITATION = 'cancel-stakeholder-invitation',
  CANCEL_SUBSCRIPTION = 'cancel-subscription',
  CAP_TABLE_EXPORT_JOB = 'cap-table-export-job',
  CAP_TABLE_SHARE_CLASSES = 'cap-table-share-classes',
  CAP_TABLE_STAKEHOLDER_BY_ALL = 'cap-table-stakeholder-by-all',
  CAP_TABLE_STAKEHOLDER_TYPES = 'cap-table-stakeholder-types',
  CAP_TABLE_STAKEHOLDERS = 'cap-table-stakeholders',
  CAP_TABLE_SUMMARIZE = 'cap-table-summarize',
  //PLAN ACTION
  CHANGE_PLAN = 'change-plan',
  CHANGE_TO_ENTERPRISE = 'change-to-enterprise',
  CHECK_AUTH_TEMPORARY_ACCESS = 'CHECK-auth-temporary-access',
  CHECK_CARD_PAYMENT_INTENT = 'check-card-payment-intent',
  CHECK_MODULE_ACCESS = 'check-module-access',
  CHECK_TEMPLATE_NAME = 'check-template-name',
  CLAIM_SUBSCRIPTION_OFFER = 'claim-subscription-offer',
  CONFIRM_CARD_SETUP = 'confirm-card-setup',
  CONVERT_SAFES = 'convert-safes',
  CREATE_COMPANY = 'create-company',
  CREATE_COMPANY_STAKEHOLDER = 'create-company-stakeholder',
  CREATE_DIVIDEND_PAYOUT = 'create-dividend-payout',
  CREATE_EVENT = 'create-event',
  //CRUD VAULT
  CREATE_FILE = 'create-file',

  CREATE_FOLDER = 'create-folder',
  //CRUD STAKEHOLDERS
  CREATE_HUMAN_STAKEHOLDER = 'create-human-stakeholder',
  CREATE_POOL = 'create-pool',
  CREATE_SAFE = 'create-safe',
  //SCENARIO MODELING
  CREATE_SCENARIO = 'create-scenario',
  CREATE_SCENARIO_CLASS_CONVERSION = 'create-scenario-class-conversion',
  CREATE_SCENARIO_CUSTOM_SAFE = 'create-scenario-custom-safe',
  CREATE_SCENARIO_GRANT = 'create-scenario-grant',
  CREATE_SCENARIO_INVESTMENT = 'create-scenario-investment',
  CREATE_SCENARIO_POOL = 'create-scenario-pool',
  CREATE_SCENARIO_SAFE = 'create-scenario-safe',
  CREATE_SHARE_CLASS = 'create-share-class',
  CREATE_SHARE_PLAN = 'create-share-plan',
  CREATE_TEMPLATE = 'create-template',
  CREATE_VERIFICATION_INTENT = 'create-verification-intent',
  DEACTIVATE_COMPANY = 'deactivate-company',
  DEACTIVATE_COUPON = 'deactivate-coupon',
  DELETE = 'delete',
  DELETE_COMPANY = 'delete-company',
  DELETE_DIVIDEND_PAYOUT = 'delete-dividend-payout',
  DELETE_EVENT = 'delete-event',
  DELETE_FILE = 'delete-file',
  DELETE_FOLDER = 'delete-folder',
  DELETE_POOL = 'delete-pool',
  DELETE_SAFE = 'delete-safe',
  DELETE_SAFE_CONVERSION = 'delete-safe-conversion',
  DELETE_SCENARIO = 'delete-scenario',
  DELETE_SCENARIO_CLASS_CONVERSION = 'delete-scenario-class-conversion',
  DELETE_SCENARIO_CUSTOM_SAFE = 'delete-scenario-custom-safe',
  DELETE_SCENARIO_GRANT = 'delete-scenario-grant',

  DELETE_SCENARIO_INVESTMENT = 'delete-scenario-investment',
  DELETE_SCENARIO_POOL = 'delete-scenario-pool',
  DELETE_SCENARIO_SAFE = 'delete-scenario-safe',
  DELETE_SHARE_CLASS = 'delete-share-class',
  DELETE_SHARE_PLAN = 'delete-share-plan',
  DELETE_STAKEHOLDER = 'delete-stakeholder',
  DELETE_TEAM_MEMBER = 'delete-team-member',
  DELETE_USER = 'delete-user',
  DIVIDEND_DISTRIBUTION = 'dividend-distribution',
  DIVIDEND_PAYOUT = 'dividend-payout',
  DIVIDEND_PAYOUT_ROWS = 'dividend-payout-rows',
  DIVIDEND_PAYOUTS = 'dividend-payouts',
  DIVIDEND_SHARE_CLASS_HOLDERS = 'dividend-share-class-holders',
  DIVIDEND_STAKEHOLDER_PAYOUTS = 'dividend-stakeholder-payouts',
  DIVIDEND_STAKEHOLDER_ROWS = 'dividend-stakeholder-rows',
  DIVIDEND_STATS = 'dividend-stats',
  DOWNLOAD_SIGNATURE_DOCUMENT = 'download-signature-document',

  DUPLICATE_SCENARIO = 'duplicate-scenario',

  EXERCISE = 'exercise',
  EXPIRE = 'expire',
  EXPORT_DIVIDEND_ALL = 'export-dividend-all',
  EXPORT_DIVIDEND_PAYOUT = 'export-dividend-payout',
  EXPORT_DIVIDEND_STAKEHOLDER = 'export-dividend-stakeholder',
  EXPORT_EVENTS = 'export-events',
  EXPORT_POOLS_PLANS = 'export-pools-plans',
  EXPORT_SAFES = 'export-safes',

  EXPORT_SNAPSHOT = 'export-snapshot',

  FILE_VIEW = 'file-view',

  FOLDER_EXPORT = 'folder-export',
  GET = 'get',

  GET_ALL_SHARE_PLANS = 'get-all-share-plans',

  GET_APPROVE_SHARE_PLANS = 'get-approve-share-plans',
  GET_APPROVE_TARGET_BASED_UNFINISHED_VESTING_TASKS = 'get-approve-target-based-unfinished-vesting-tasks',
  GET_APPROVE_TARGET_BASED_VESTING_TASKS = 'get-approve-target-based-vesting-tasks',
  GET_AUTOMATIC_VESTING_SHARE_PLAN = 'get-automatic-vesting-share-plan',
  GET_CARD_SETUP_INTENT_SECRET = 'get-setup-card-intent-secret',
  GET_CITY = 'get-city',
  GET_CLIENT_SECRET = 'get-client-secret',
  GET_COMPANIES = 'get-companies',
  //CRUD COMPANY
  GET_COMPANY = 'get-company',
  GET_COMPANY_DETAILS = 'get-company-details',
  GET_COMPANY_EXCLUDED_BALANCE = 'get-company-excluded-balance',
  GET_COMPANY_GET_STARTED_PROGRESS = 'get-company-get-started-progress',
  GET_COMPANY_INCORPORATION_CONTEXT = 'get-company-incorporation-context',
  GET_COMPANY_INVOICES = 'get-company-invoices',
  GET_CONVERSION_SUMMARY = 'get-conversion-summary',
  //COUNTRY
  GET_COUNTRY = 'get-country',
  GET_COUPON = 'get-coupon',

  //CURRENCY
  GET_CURRENCY = 'get-currency',
  //VESTING TASK
  GET_CURRENT_VALUATION = 'get-current-valuation',

  GET_DEFAULT_SHARE_CLASS = 'get-default-share-class',
  GET_EQUITY_GRAPH_DATA = 'get-equity-graph-data',
  GET_EVENT = 'get-event',
  GET_EVENT_TRANSACTIONS = 'get-event-transactions',
  GET_EVENT_TRANSACTIONS_COUNT = 'get-event-transactions-count',
  //CRUD EVENT
  GET_EVENTS = 'get-events',
  GET_EXERCISABLE_VESTING_SHARE_PLAN = 'get-exercisable-vesting-share-plan',
  GET_HARDCODED_REPOSITORY = 'get-hardcoded-repository',
  GET_HARDCODED_REPOSITORY_FILES = 'get-hardcoded-repository-files',
  GET_INVESTMENT_HISTORY = 'get-investment-history',
  GET_INVESTMENT_SUMMARY = 'get-investment-summary',
  //STAKEHOLDER ACTIONS
  GET_INVITATION = 'get-invitation',
  GET_IP_COUNTRY_CODE = 'get-ip-country-code',
  GET_ISSUED_SHARES = 'get-issued-shares',
  //USER ACTIONS
  GET_LOGOUT = 'get-logout',
  GET_MODIFIED_SHARE_CLASSES = 'get-modified-share-classes',
  //NOTIFICATION
  GET_NOTIFICATIONS = 'get-notifications',
  GET_OPEN_FILES = 'get-open-files',

  GET_OPEN_REPOSITORY = 'get-open-repository',
  GET_PAYMENT_DATA = 'get-payment-data',
  GET_PAYMENT_SESSION_ID = 'get-payment-session-id',
  GET_PENDING_SUBSCRIPTION_OFFER = 'get-pending-subscription-offer',
  GET_PHANTOM_VESTING_TASKS = 'get-phantom-vesting-tasks',
  GET_PLANS = 'get-plans',
  //CRUD POOL
  GET_POOL = 'get-pool',
  GET_POOL_BY_SHARE_PLAN = 'get-pool-by-share-plan',
  GET_POOLS = 'get-pools',
  GET_POOLS_BY_STAKEHOLDER = 'get-pools-by-stakeholder',

  GET_REQUESTED_VESTING_TASKS = 'get-requested-vesting-tasks',
  //STRIPE
  GET_RETRIEVE_PAYMENT_INTENT = 'get-retrieve-payment-intent',

  GET_SAFE = 'get-safe',

  GET_SAFE_CONVERSION = 'get-safe-conversion',
  GET_SAFE_CONVERSION_PROGRESS = 'get-safe-conversion-progress',
  GET_SAFE_CONVERSION_SUMMARY = 'get-safe-conversion-summary',
  GET_SAFE_OVERALL_STATUS = 'get-safe-overall-status',
  GET_SAFE_RECAP = 'get-safe-recap',
  //CRUD SAFE
  GET_SAFES = 'get-safes',
  GET_SCENARIO = 'get-scenario',
  GET_SCENARIO_CLASS_CONVERSION_TASKS = 'get-scenario-class-conversion-tasks',
  GET_SCENARIO_CLASS_CONVERSIONS = 'get-scenario-class-conversions',
  GET_SCENARIO_CUSTOM_SAFES = 'get-scenario-custom-safes',
  GET_SCENARIO_GRANTS = 'get-scenario-grants',
  GET_SCENARIO_INVESTMENTS = 'get-scenario-investments',
  GET_SCENARIO_POOLS = 'get-scenario-pools',
  GET_SCENARIO_SAFES = 'get-scenario-safes',
  GET_SCENARIO_VESTING_SARS = 'get-scenario-vesting-sars',
  GET_SCENARIO_VESTING_TASKS = 'get-scenario-vesting-tasks',
  GET_SCENARIOS = 'get-scenarios',
  GET_SCENARIOS_SARS = 'get-scenario-sars',
  GET_SELECTED_COMPANY = 'get-selected-company',
  GET_SELECTED_COMPANY_ID = 'get-selected-company-id',
  GET_SHARE_CLASS = 'get-share-class',
  //CRUD SHARE CLASSES
  GET_SHARE_CLASSES = 'get-share-classes',
  GET_SHARE_CLASSES_STATS = 'get-share-classes-stats',
  GET_SHARE_PLAN = 'get-plan',

  GET_SHARE_PLAN_VESTING_TASKS = 'get-share-plan-vesting-tasks',
  //CRUD SHARE PLAN
  GET_SHARE_PLANS = 'get-share-plans',
  GET_SHARE_PLANS_BY_STAKEHOLDER = 'get-share-plans-by-stakeholder',
  GET_SIGNATURE_PREVIEW = 'get-signature-preview',
  GET_SIGNATURES = 'get-signatures',
  GET_SNAPSHOT = 'get-snapshot',
  GET_SNAPSHOT_BY_DATE = 'get-snapshot-by-date',
  //SNAPSHOT
  GET_SNAPSHOTS = 'get-snapshots',
  GET_STAKEHOLDER = 'get-stakeholder',
  GET_STAKEHOLDER_BALANCE = 'get-stakeholder-balance',
  GET_STAKEHOLDER_CONSOLIDATED_POSITION = 'get-stakeholder-consolidated-position',
  GET_STAKEHOLDER_EXCLUDED_BALANCE = 'get-stakeholder-excluded-balance',
  GET_STAKEHOLDER_OWNERSHIP_SUMMARY = 'get-stakeholder-ownership-summary',
  GET_STAKEHOLDER_REVERSE_VESTING = 'get-stakeholder-reverse-vesting',

  GET_STAKEHOLDER_SAFES = 'get-stakeholder-safes',
  GET_STAKEHOLDER_STATS = 'get-stakeholder-stats',
  GET_STAKEHOLDER_TYPES_STATS = 'get-stakeholder-types-stats',
  GET_STAKEHOLDERS = 'get-stakeholders',
  GET_STAKEHOLDERS_FOR_EXERCISE = 'get-stakeholders-for-exercise',
  GET_STAKEHOLDERS_WITH_GRANTS = 'get-stakeholders-with-grants',
  GET_STAKEHOLDERS_WITH_SHARES = 'get-stakeholders-with-shares',
  GET_STATE = 'get-state',

  GET_STATS = 'get-stats',
  GET_SUBSCRIPTION_OFFER = 'get-subscription-offer',
  //TARGET BASED MILESTONES
  GET_TARGET_BASED_MILESTONES = 'get-target-based-milestones',
  GET_TEAM = 'get-team',
  GET_TEAM_MEMBER = 'get-team-member',
  GET_TEAM_MEMBER_BY_EMAIL = 'get-team-member-by-email',
  GET_TEMPLATE_BY_ID = 'get-template-by-id',
  GET_TEMPLATE_DOCUMENT = 'get-template-document',
  GET_TEMPLATE_FIELD_AVAILABILITY = 'get-template-field-availability',
  GET_TEMPLATE_PREVIEW = 'get-template-preview',
  GET_TEMPLATES = 'get-templates',
  GET_TERMINATED_POOLS = 'get-terminated-pools',
  GET_TERMINATED_STAKEHOLDERS_FOR_EXERCISE = 'get-terminated-stakeholders-for-exercise',
  GET_UNREAD_NOTIFICATION_COUNT = 'get-unread-notification-count',
  //CRUD USER
  GET_USER = 'get-user',
  GET_VALUATION = 'get-valuation',
  GET_VAULT_FOLDER = 'get-vault-folder',
  GET_VAULT_FOLDERS = 'get-vault-folders',
  GET_VESTING_GRAPH = 'get-vesting-graph',
  GET_VESTING_TASKS = 'get-vesting-tasks',
  GET_VESTING_TASKS_STRUCTURE = 'get-vesting-tasks-structure',
  /** Agent eval fixtures only — not production API */
  GET_WIDGET_EVAL_DETAIL = 'get-widget-eval-detail',
  /** Agent eval fixtures only — not production API */
  GET_WIDGETS_EVAL = 'get-widgets-eval',
  GRANT_AUTH_TEMPORARY_ACCESS = 'grant-auth-temporary-access',

  GRANT_BULK_IMPORT = 'grant-bulk-import',
  INVITE_STAKEHOLDER = 'invite-stakeholder',
  IS_COMPANY_HAVE_SAVES = 'is-company-have-safes',
  IS_HAVE_SAFES = 'is-have-safes',
  IS_HAVE_VESTING_TASKS = 'is-have-vesting-tasks',
  IS_USER_HAVE_COMPANY = 'is-user-have-company',
  LIQUIDITY_GRAPH_DATA = 'liquidity-graph-data',
  MARK_NOTIFICATION_AS_READ = 'mark-notification-as-read',
  MARK_NOTIFICATION_AS_RESOLVED = 'mark-notification-as-resolved',
  NOTIFICATION_EXERCISE_REQUEST = 'notification-exercise-request',
  OFFER_CHECKOUT_SESSION = 'offer-checkout-session',
  OPEN_DRIVE_EXPORT = 'open-drive-export',
  //CHECK
  PASSWORD_RECOVERY_ID_CHECK = 'password-recovery-id-check',
  PATCH = 'patch',
  PATCH_COMPANY = 'patch-company',

  PATCH_EVENT = 'patch-event',
  PATCH_EXERCISE_EVENT_DOCUMENTS = 'patch-exercise-event-documents',
  PATCH_POOL = 'patch-pool',
  PATCH_SAFE = 'patch-safe',
  PATCH_SCENARIO = 'patch-scenario',
  PATCH_SCENARIO_CLASS_CONVERSION = 'patch-scenario-class-conversion',
  PATCH_SCENARIO_CUSTOM_SAFE = 'patch-scenario-custom-safe',
  PATCH_SCENARIO_GRANT = 'patch-scenario-grant',
  PATCH_SCENARIO_INVESTMENT = 'patch-scenario-investment',
  PATCH_SCENARIO_POOL = 'patch-scenario-pool',
  PATCH_SCENARIO_SAFE = 'patch-scenario-safe',
  PATCH_SELECTED_COMPANY = 'patch-selected-company',
  PATCH_SHARE_CLASS = 'patch-share-class',
  PATCH_SHARE_PLAN = 'patch-share-plan',
  PATCH_STAKEHOLDER = 'patch-stakeholder',
  PATCH_TEAM_MEMBER = 'patch-team-member',
  PATCH_TERMINATE_STAKEHOLDERS = 'patch-terminate-stakeholders',
  PATCH_USER = 'patch-user',
  PATCH_USER_NOTIFICATION_SETTINGS = 'patch-user-notification-settings',
  PERKS = 'perks',
  PIN_EVENT = 'pin-event',
  POOL_NAME_CHECK = 'pool-name-check',
  POST = 'post',
  PREDICT_TERMINATION_VESTING = 'predict-termination-vesting',
  PREVIEW_REVERSE_VESTING_TERMINATION = 'preview-reverse-vesting-termination',
  QUICK_SIGN = 'quick-sign',
  //COMPANY ACTIONS
  REACTIVATE_COMPANY = 'reactivate-company',
  REFOUND_VERIFICATION_INTENT = 'refound-verification-intent',
  //VERIFY
  REGISTER_VERIFY = 'register-verify',
  RENAME_FILE = 'rename-file',
  RENAME_FOLDER = 'rename-folder',
  /** Agent eval fixtures only — not production API */
  RENAME_WIDGET_EVAL = 'rename-widget-eval',
  REQUEST_MORE_ENVELOPES = 'request-more-envelopes',
  SAFE_DOWNLOAD_TEMPLATE = 'safe-download-template',
  //SAFES
  SAFES_BULK_IMPORT = 'safes-bulk-import',
  SCENARIO_EXPORT = 'scenario-export',
  SELECT_COMPANY = 'select-company',
  SEND_SIGNATURE_REMINDER = 'send-signature-reminder',
  SET_SHARE_CLASS_DOC = 'set-share-class-doc',
  SHARE_CLASS_NAME_CHECK = 'share-class-name-check',
  SHARE_PLAN_NAME_CHECK = 'share-plan-name-check',
  SHARE_PLAN_STAKEHOLDERS = 'share-plan-stakeholders',
  SHARED_CAP_TABLE_LINK_CREATE = 'shared-cap-table-link-create',
  SHARED_CAP_TABLE_LINK_DELETE = 'shared-cap-table-link-delete',
  SHARED_CAP_TABLE_LINK_UPDATE = 'shared-cap-table-link-update',
  SHARED_CAP_TABLE_LINKS = 'shared-cap-table-links',
  SIGNATURE_RECIPIENT_VIEW = 'signature-recipient-view',
  SIGNATURE_SYNC_EMBEDDED_SESSION = 'signature-sync-embedded-session',
  SIGNATURES_LINKED_TARGET_OPTIONS = 'signatures-linked-target-options',
  STAKEHOLDERS_BULK_IMPORT = 'stakeholders-bulk-import',
  STAKEHOLDERS_BULK_MODIFY = 'stakeholders-bulk-modify',
  STAKEHOLDERS_COUNT = 'stakeholders-count',
  STAKEHOLDERS_DOWNLOAD_INFO = 'stakeholders-download-info',
  STAKEHOLDERS_DOWNLOAD_TEMPLATE = 'stakeholders-download-template',
  STAKEHOLDERS_EXPORT = 'stakeholders-export',
  SUBSCRIPTION_PAYMENT = 'subscription-payment',
  TERMINATE_POOL = 'terminate-pool',
  TERMINATE_SHARE_PLAN = 'terminate-share-plan',
  TERMINATE_STAKEHOLDERS = 'terminate-stakeholders',
  TOGGLE_STAKEHOLDER_ACCESS = 'toggle-stakeholder-access',
  TOGGLE_STAKEHOLDER_STATUS = 'toggle-stakeholder-status',
  /** Agent eval fixtures only — not production API */
  TOGGLE_WIDGET_EVAL = 'toggle-widget-eval',
  TRANSITION_DIVIDEND_STATUS = 'transition-dividend-status',
  UPDATE_DIVIDEND_DATE = 'update-dividend-date',
  UPDATE_DIVIDEND_PAYOUT = 'update-dividend-payout',
  VAULT_FILE_DOWNLOAD = 'vault-file-download',
  VERIFICATION_ID_CHECK = 'verification-id-check',
}
